var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/DownloadFill",
    fill: "#6C7DBC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 18,
    width: 16,
    height: 2,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 9,
    y: 2,
    width: 5.69432831,
    height: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6823183,9.63683037 L17.6452979,14.2689447 C18.0490486,14.6457787 18.0708689,15.2785676 17.6940349,15.6823183 C17.5049089,15.8849533 17.2401613,16 16.9629797,16 L7.03702032,16 C6.48473557,16 6.03702032,15.5522847 6.03702032,15 C6.03702032,14.7228184 6.15206701,14.4580708 6.35470207,14.2689447 L11.3176817,9.63683037 C11.7018885,9.27823739 12.2981115,9.27823739 12.6823183,9.63683037 Z",
    id: "Triangle",
    transform: "translate(12.000000, 12.500000) scale(1, -1) translate(-12.000000, -12.500000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFill);
export default __webpack_public_path__ + "static/media/DownloadFill.12175b245d5a4fbeb4a60cb5e6de748e.svg";
export { ForwardRef as ReactComponent };